<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-0">
            <p class="title mb-4">{{titleCancelacionReservaciones}}</p>
            <p class="link f-w-500 mb-2">
              <i class="demo-icon icon-travel"></i>{{$t('language.posadasCorporate.cancelarReservaciones.datosGenerales')}}
            </p>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.cancelarReservaciones.clienteID')}}*</label>
              <div class="Pos-r">
                <input type="text" class="form-control mayuscula"
                  v-model="cliente" maxlength="50"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.cancelarReservaciones.nombreUsuario')}}*</label>
              <div class="Pos-r">
                <input type="text" class="form-control minuscula"
                  v-model="usuario" maxlength="50"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.cancelarReservaciones.correoElectronico')}}*</label>
              <div class="Pos-r">
                <input type="email" :placeholder="$t('language.posadasCorporate.cancelarReservaciones.ejemplo') + '@' + $t('language.posadasCorporate.cancelarReservaciones.correo') + '.com'" class="form-control"
                 maxlength="50"
                  v-model="correo"
                  :class="{ 'is-invalid': (!$v.correo.email)}"/>
                <span class="notas" v-if="!$v.correo.email">{{$t('language.posadasCorporate.reservacionesRegistro.invalidEmail')}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.cancelarReservaciones.claveConfirmacion')}}*</label>
              <div class="Pos-r">
                <input type="number" :placeholder="$t('language.posadasCorporate.cancelarReservaciones.caracteres10')" class="form-control"
                    :value="clave" @input="updateValue" onkeypress="return event.key === 'Enter' || (Number(event.key) >= 0 && Number(event.key) <= 9)"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-element" v-click-outside="outsideMotivo">
              <label>{{$t('language.posadasCorporate.cancelarReservaciones.motivoCancelacion')}}*</label>
              <div class="Pos-r" v-if="banMotivosCancelacion">
                <div class="contenidoSearch" @click="[motivoActive = true]">
                  <i class="search-icons icon-unfold-more" v-if="!motivoActive"></i>
                  <i class="search-icons icon-close pointer" v-if="motivoActive" @click="[motivoSeleccionado = '', typeMotivoSeleccionado = '']"></i>
                  <input class="elipse cursor-pointer" type="text" :placeholder="$t('language.posadasCorporate.cancelarReservaciones.seleccionar')" autocomplete="nope"
                    readonly
                    @click="filteredListMotivo" v-model="motivoSeleccionado">
                </div>

                <div class="card buscadorCard vb" style="width: 93%;" v-if="motivoActive" v-bar>
                  <div>
                    <div class="buscador" v-for="filtrado in filter" :key="filtrado.id">
                      <p class="mb-1 nombre" @click="[cambiaFiltrado(filtrado.descripcion, filtrado.cancelType), filtrado = 0, motivoActive = false]" v-html="$options.filters.resalt( filtrado.descripcion , motivoSeleccionado)"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-8">
            <div class="form-element">
              <label>{{$t('language.posadasCorporate.cancelarReservaciones.comentariosAdicionales')}}</label>
              <div class="Pos-r">
                <textarea v-model="adicionales" maxlength="255"></textarea>
                <label for="" class="notas">{{$t('language.posadasCorporate.generals.max255Caracteres')}}</label><br><br>

                <small>* {{$t('language.posadasCorporate.cancelarReservaciones.camposRequeridos')}}</small>
              </div>
            </div>
          </div>

          <div class="col-12 mt-2 mb-5">
            <Loader v-if="banLoader"/>
            <div class="row">
              <div class="col-4 "></div>
              <div class="col-12 col-md-4">
                <router-link to="/informacion-corporate" tag="button" class="mt-3 secondary-button">
                  {{$t('language.posadasCorporate.cancelarReservaciones.regresar')}}
                </router-link>
              </div>
              <div class="col-12 col-md-4">
                <button class="mt-3 primary-button" @click="enviar"
                  :disabled='isDisabled || banLoader'>{{$t('language.posadasCorporate.cancelarReservaciones.enviar')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-show="isModalVisible" @close="closeModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde"> <i class="demo-icon icon-check-fill Fw-bolder"></i> {{$t('language.posadasCorporate.cancelarReservaciones.titleModal')}}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{textModal}}</p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeModal"
          aria-label="Close modal">
          {{$t('language.posadasCorporate.cancelarReservaciones.entendido')}}
        </button>
      </template>
    </modal>
    <Footer />
  </div>
</template>

<script>
  import * as GlobalServices from '../../../utils/GlobalServices';
  import * as GlobalFunctions from '../../../utils/GlobalFunctions';
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  import Datepicker from 'vue2-datepicker';
  import Modal from '../../addons/Modal.vue';
  import SecureLS from 'secure-ls';
  import Loader from '../../loader/Loader'
  import i18n from '../../../plugins/i18n';
  import { required, email } from "vuelidate/lib/validators";

  export default {
    name: 'Contacto',
    components: {
      Header,
      Footer,
      Datepicker,
      Modal,
      Loader
    },
    data() {
      return {
        validRegex: /^[a-zA-Z\\d\\1-9\\0]*$/,
        validRegexEmail: /^[a-zA-Z\\d\\1-9\\0\\.\\_\\@\\-]*$/,
        validRegexUsuario: /^[a-zA-Z\\d\\.]*$/,
        localLanguage: '',
        banMotivosCancelacion: false,
        ls: new SecureLS({encodingType: 'aes'}),
        isModalVisible: false,
        textModal: '',
        banLoader: false,
        cliente: '',
        usuario: '',
        correo: '',
        clave: '',
        adicionales: '',
        motivoActive: false,
        filtrado: false,
        motivoSeleccionado: '',
        typeMotivoSeleccionado: '',
        filter: '',
        motivos: [],
      }
    },
    validations: {
      correo: {
        required,
        email,
      },
    },
    watch: {
      correo() {
        
            let str = "";
            if (!this.validRegexEmail.test(this.correo)) {
              str = this.correo.substring(0, this.correo.length - 1);
              this.correo = str;
            }
      },
      usuario() {
            let str = "";
            if (!this.validRegexUsuario.test(this.usuario)) {
              str = this.usuario.substring(0, this.usuario.length - 1);
              this.usuario = str;
            }
      },
        cliente() {
          let str = "";
            if (!this.validRegex.test(this.cliente)) {
              str = this.cliente.substring(0, this.cliente.length - 1);
              this.cliente = str;
            }
        }
    },
    methods: {
       updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 10) {
        this.clave = value
      }
      this.$forceUpdate()
    },
        isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46 && charCode === 69) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
      enviar() {
        this.banLoader = true;
        const localProfile = this.ls.get('Profile').data;
        var data = {
          profileId: this.cliente.toUpperCase(),
          username: this.usuario.toLowerCase(),
          userType: localProfile.userType,
          reservationNumber: this.clave,
          email: this.correo,
          cancelationMotive: this.typeMotivoSeleccionado,
          cancelationReason: this.adicionales
        }
        GlobalServices._cancelarAclaracionReservacion(this.ls.get('Token').data, this.ls.get('Language').data, data).then(response => {
          if (response.status === 200) {
            this.textModal = response.data.message;
            this.banLoader = false;
            this.isModalVisible = true;
          } else {
            this.$router.push({ name: "Error" });
          }
        }).catch(error => {
          this.banLoader = false;
          if (error.status == 401) {
            this.sesionClose();
          } else{
            this.$router.push({ name: "Error" });
          }
        });
      },
      closeModal() {
        this.isModalVisible = false;
        setTimeout(() => {
          this.$router.push({ name: "InformacionCorporate" });
        }, 200);
      },
      filteredListMotivo() {
        return this.filter = this.motivos
      },
      cambiaFiltrado(descripcion, type) {
        this.typeMotivoSeleccionado = type;
        return this.motivoSeleccionado = descripcion;
      },
      outsideMotivo(e) {
        this.motivoActive = false;
      },
      limpiarForm(){
        this.closeModal();
        setTimeout(() => {
          this.textModal = '';
          this.cliente = '';
          this.usuario = '';
          this.correo = '';
          this.clave = '';
          this.adicionales = '';
          this.motivoSeleccionado = '';
          this.typeMotivoSeleccionado = '';
        }, 350);
      },
      sesionClose(){
        GlobalFunctions.localStorageClean();
        this.$router.push({ name: 'Login'})
      },
      serviceConsultaMotivosCancelacion(){

      },
      consultaMotivosCancelacion(lugar){
        if (this.ls.get('comboMotivosCancelacion') === '' || lugar === 2) {
          if (lugar === 2) {
            this.ls.remove('comboMotivosCancelacion');
          }
          GlobalServices._consultaMotivosCancelacion(this.ls.get('Token').data, this.ls.get('Language').data).then(response => {
            this.motivos = response.data;
            this.banMotivosCancelacion = true;
            this.ls.set('comboMotivosCancelacion', { data: response.data });
          }).catch( error => {
            if (error.status == 401) {
              this.sesionClose();
            }
          });
        } else{
          this.banMotivosCancelacion = true;
          this.motivos = this.ls.get('comboMotivosCancelacion').data;
        }
      },
    },
    created(){
      this.localLanguage = this.ls.get('Language').data;
      this.consultaMotivosCancelacion(1);

    },
    destroyed() {
      this.ls.remove('comboMotivosCancelacion');
    },
    computed: {
      isDisabled() {
        if (this.correo.length > 1 && this.cliente.length >= 2 && this.usuario.length >= 2 && this.clave.length >= 1 && this.typeMotivoSeleccionado != '') {
          if (this.correo.length != '') {
            if (this.correo.length > 6 && this.$v.correo.email) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
      titleCancelacionReservaciones(){
        if (this.localLanguage !== this.ls.get('Language').data) {
          this.localLanguage = this.ls.get('Language').data;
          this.banMotivosCancelacion = false;
          this.motivoSeleccionado = '';
          this.typeMotivoSeleccionado = '';
          this.consultaMotivosCancelacion(2);
        }
        return i18n.t('language.posadasCorporate.cancelarReservaciones.cancelacionReservaciones')
      }
    },
    filters: {
      resalt: function (value, valueFromSearch) {
        if (!value) return ''
        valueFromSearch != '' ? value = value.replace(valueFromSearch,
            '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>'
            ) : value = value;
        return value;
      }
    },
    directives: {
        'click-outside': {
        bind: function(el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler

          // add Event Listeners
          document.addEventListener('click', handler)
        },

        unbind: function(el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .card-height-custom {
    min-height: 213.67px;
    height: 213.67px;
    .card-body {
      min-height: 213.67px;
      height: 213.67px;
    }
  }
  textarea {
    height: 130px;
  }
</style>